import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { VideoPlayButton } from '../atoms';
// 動画は 16:9 で固定しています
const ASPECT_RATE_WIDTH = 16;
const ASPECT_RATE_HEIGHT = 9;
export const LBPlayerContainer = ({ classObject, children, playButtonVisible, playerHidden, onClickPlayButton, }) => {
    return (React.createElement("div", { className: css(styles.container, classObject) },
        React.createElement("div", { className: css(styles.playerWrapper, playButtonVisible && styles.playerWrapperNoEvents, playerHidden && styles.playerHidden), "data-test": "videoPlayer" }, children),
        React.createElement(VideoPlayButton, { visible: playButtonVisible, onClick: onClickPlayButton, className: css(styles.playButton) })));
};
const styles = StyleSheet.create({
    container: {
        padding: `${(ASPECT_RATE_HEIGHT / ASPECT_RATE_WIDTH) * 100}% 0 0 0`,
        position: 'relative',
    },
    playerWrapper: {
        width: '100%',
        height: '100%',
        display: 'inherit',
        position: 'absolute',
        top: 0,
        left: 0,
    },
    playerHidden: {
        display: 'none',
    },
    playerWrapperNoEvents: {
        pointerEvents: 'none',
    },
    playButton: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    },
});
